<template lang="html">
  <div
   class="flex justify-center text-center leading-none mt-8">
   <button
     @click="open()"
     class="border-black border-2 py-3 px-8 bg-herored text-white"
    >
    Sign In
   </button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
      open() {
        this.$emit('openModal', true);
      }
    }
  }
</script>
